import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { SvgDragLarge } from "melodies-source/Svgs/DragLarge";
import styled from "styled-components";

export interface SortableRowProps {
  id: string | number;
  children?: React.ReactNode;
}

export const SortableRow = ({ id, children }: SortableRowProps) => {
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
  });

  const style = {
    opacity: isDragging ? 0 : 1,
    transform: CSS.Translate.toString(transform),
    transition,
  };

  return (
    <SortRowContainer ref={setNodeRef} style={style}>
      <Handle {...attributes} {...listeners} style={{ cursor: "grab" }}>
        <SvgDragLarge />
      </Handle>
      {children}
    </SortRowContainer>
  );
};

const SortRowContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  position: relative;
  padding: 0;
`;

const Handle = styled.div`
  background-color: #f2f5f7;
  width: 32px;
  flex-grow: 0;
  display: flex;
  align-items: flex-start;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  margin-top: 30px;
  svg {
    color: #a9b8c2;
    width: 34px;
    height: 34px;
    margin-left: -1px;
    flex-shrink: 0;
  }
`;
